var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dados-edital',{model:{value:(_vm.licitacao),callback:function ($$v) {_vm.licitacao=$$v},expression:"licitacao"}})}
var staticRenderFns = []

export { render, staticRenderFns }